import {
  FETCH_USER_AI_MEMORY,
  FETCH_USER_AI_MEMORY_SUCCESS,
  FETCH_USER_AI_MEMORY_FAILED,
  FETCH_ALL_AI_MEMORY,
  FETCH_ALL_AI_MEMORY_SUCCESS,
  FETCH_ALL_AI_MEMORY_FAILED,
} from '../store/types';

const INITIAL_STATE = {
  userMemories: {},   // { [uid]: memoryObject }
  allMemories:  null, // { [uid]: memoryObject } — cargado en bloque para el admin
  loading: false,
  error:   null,
};

export const aimemoryreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_USER_AI_MEMORY:
    case FETCH_ALL_AI_MEMORY:
      return { ...state, loading: true, error: null };

    case FETCH_USER_AI_MEMORY_SUCCESS:
      return {
        ...state,
        loading: false,
        userMemories: {
          ...state.userMemories,
          [action.payload.uid]: action.payload.memory,
        },
      };

    case FETCH_ALL_AI_MEMORY_SUCCESS:
      return { ...state, loading: false, allMemories: action.payload };

    case FETCH_USER_AI_MEMORY_FAILED:
    case FETCH_ALL_AI_MEMORY_FAILED:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
